import { useContext } from 'react';

import '../init';
import { windowIsAvailable } from '../utils';
import { ToasterContext } from '../components/Toaster/Context';

/**
 * @example const { push } = useToaster();
 * @returns ...
 */
const useToaster = () => {
  const context = windowIsAvailable
    ? window.cosmos.toasterContext ?? ToasterContext
    : ToasterContext;

  return useContext(context);
};

export default useToaster;
